import { render, staticRenderFns } from "./moreDropdown.vue?vue&type=template&id=8089d330&scoped=true"
import script from "./moreDropdown.vue?vue&type=script&lang=js"
export * from "./moreDropdown.vue?vue&type=script&lang=js"
import style0 from "./moreDropdown.vue?vue&type=style&index=0&id=8089d330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089d330",
  null
  
)

export default component.exports